import {createTheme} from "@mui/material";

const darkTheme = createTheme({
  palette: {
    //mode: 'dark',
    primary: {
      main: '#3f51b5',
      light: '#55aaff',
      dark: '#1f1f47',
      contrastText: '#ffffff',
    },
    pink: {
      main: '#fdb3ed',
      light: '#ffe0f9',
      dark: '#4c1b50',
      contrastText: '#2c2a2a',
    },
    violet: {
      main: '#7F00FF',
      light:'#c690f6',
      dark: '#3b0077',
      contrastText: '#ffffff',
    },
    lilac: {
      main: '#b3b3ff',
      light: '#e6e6ff',
      dark: '#8774e1',
      contrastText: '#ffffff',
    },
  },
  colors: {
    background: '#0e1e32',
    lightBackground: '#1f1f47',
    darkBackground: '#05142c',
    darkGrey: '#939393',
    lightGrey: '#eaeaea',
    lightBlue: '#55aaff',
    button: '#3f51b5',
    disabledButton: '#939393',
    blackText: '#2c2a2a',
    audioPlayer: '#f2f3f3',
    defaultIconButton: '#ffffff',
    labelBackground: '#1f1f47',
    white: '#eaeaea',
  },
  text: {
    primary: '#ffffff',
    light: '#eaeaea',
    darkGrey: '#939393',
    secondary: '#1e1a1a',
  },
  fields: {
    background: '#eaeaea',
  },
  alerts: {
    success: '#92ff92',
    error: '#ff6161',
  },
  padding: {
    box: '2rem',
  },
});

export default darkTheme;